const header = {
  admin: '管理者情報一覧',
  adminDetail: '管理者情報詳細',
  addAdmin: '管理者情報新規登録',
  adminCompany: '企業検索',
  jobSearch: '求人検索',
  jobInformation: '求人情報',
  companyDetail: '企業情報',
  jobSearchDetail: '求人情報',
  member: 'ジョブペイ会員検索',
  memberDetail: 'ジョブペイ会員詳細',
  advertisementfee: '広告掲載料確認',
  commentReview: 'コメント審査',
  company: '企業情報',
  commercialTransactions: '特定商取引に関する法律に基づく表示',
  privacyPolicy: 'プライバシーポリシー',
  antiSocial: '反社会的勢力に対する基本方針',
  termOfUse: 'JOBPAY利⽤規約',
  publicRule: '掲載規定',
  companyPayment: '金額確認',
  companyUserDetail: 'ユーザー詳細',
  commentDetail: '評価詳細'
}

export default {
  header
}